<template>
  <div class="tableTimeSlot">
    <div>{{scope.scope.timeStr}}</div>
    <div>{{scope.text}}</div>
  </div>
</template>
<script>
export default {
  props: {
    instance: Object,
    scope: Object // text, index, scope
  },
  data () {
    return {

    }
  }
}
</script>